import React from 'react';
import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => ({
  parentContainer: {
    height: '75vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center'
  },
  childContainer: {
    width: '100%',
    fontSize: '16px'
  },
  button: {
    width: '100%',
    marginTop: '30px'
  }
}));

export default useStyles;
